import { render, staticRenderFns } from "./SuppliesDetails.vue?vue&type=template&id=24c5b21e"
import script from "./SuppliesDetails.vue?vue&type=script&lang=js"
export * from "./SuppliesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports